import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PanelProps {
  title?: string;
  subtitle?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Hairline-bounded surface panel. Carries section-level content;
 * brand-aligned, no shadow, no rounded corners beyond 4px. Build guide
 * §2 "Component approach".
 */
export function Panel({ title, subtitle, className, children }: PanelProps) {
  return (
    <section className={cn('bg-bg-panel border border-rule', className)}>
      {(title || subtitle) && (
        <header className="flex items-center justify-between px-5 py-3 border-b border-rule">
          {title && <h3 className="m-0 text-[11px] font-bold uppercase tracking-heading text-fg-default">{title}</h3>}
          {subtitle && <span className="text-[11px] text-fg-muted">{subtitle}</span>}
        </header>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}
